import React from "react";
import { NavLink } from "react-router-dom";

interface Props {
  icon: React.ReactNode;
  title: string;
  path: string;
}

const NavItem = ({ icon, title, path }: Props) => {
  return (
    <NavLink
      to={path}
      className={({ isActive }) =>
        `relative flex justify-end flex-col items-center flex-grow flex-shrink-0 p-0 m-0 text-center text-xs font-medium h-[49px] ${
          isActive ? "text-gray-900" : "text-gray-500"
        }`
      }
    >
      <div className="flex flex-col justify-center items-center text-center pt-2">
        <div>{icon}</div>
        <div className="w-full text-xs overflow-ellipsis whitespace-nowrap">
          {title}
        </div>
      </div>
    </NavLink>
  );
};

export default NavItem;
